<template>
  <div class="page">
    <b-row class="tomador-header">
      <b-col class="d-flex align-items-center">
        <ul class="datos-tomador">
          <b-row>
            <b-col class="d-flex text-md-left" sm="9">
              <h2 class="tomador-title">{{ tomador.nombre }}</h2>
            </b-col>
            <!--b-col class="d-flex align-items-center" sm="3">
              <b-dropdown variant="outline-primary" text="large" class="m-md-2" no-caret>
                <template v-slot:button-content>
                  <i class="fa fa-gear text-white"></i>
                  <span class="sr-only">Opciones</span>
                </template>
                <b-dropdown-item @click="$refs.cambioMail.toggle()">Cambiar mail</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="$refs.cambioTel.toggle()">Cambiar teléfono</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="$refs.modalInstrumentoPago.toggle()">Cambiar instrumento de pago</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="$refs.modalInformePago.toggle()">Informar pago</b-dropdown-item>
              </b-dropdown>
            </b-col-->
          </b-row>
          <b-row class="boton-tomador-polzias">
            <b-button variant="light" v-model="verTomadorPolizasAll" name="vistas-polizas" @click="selectVistaPolizas()">
              <b>{{ vistaPolizasTomador }}</b>
            </b-button>
          </b-row>
        </ul>
      </b-col>
      <b-col class="d-flex justify-content-end align-items-center">
        <ul class="datos-tomador">
          <li>
            <i class="fa fa-address-card-o" style="width: 20px;"></i>
            {{ tomador.email | lower }}
            <b-tooltip placement="lefttop" target="linkmail">Cambiar Mail</b-tooltip>
            <a id="linkmail" style="cursor: pointer;" @click="$refs.cambioMail.toggle()"><i class="fa fa-pencil"></i></a>
          </li>
          <li>
            <i class="fa fa-phone" style="width: 20px;"></i>
            {{ tomador.telefono }}
            <b-tooltip placement="lefttop" target="linktel">Cambiar Telefono</b-tooltip>
            <a id="linktel" style="cursor: pointer;" @click="$refs.cambioTel.toggle()"><i class="fa fa-pencil"></i></a>
          </li>
          <li>
            <i class="fa fa-building-o" style="width: 20px;"></i>
            {{ tomador.direccion }} - {{ tomador.localidad }} - {{ tomador.provincia }}
          </li>
        </ul>
      </b-col>
    </b-row>
    <b-card no-body v-if="endosoSelected">
      <b-tabs card nav-class="tomador-tabs" v-model="ramoSelectedIndex">
        <b-tab v-for="(ramo, index) in ramos" :key="index" @click="selectRamo(ramo)">
          <template v-slot:title>
            <strong v-if="ramo == 'PROPERTY'" class="tab-text">RESTO DE RAMOS</strong>
            <strong v-else class="tab-text">{{ ramo }}</strong>
          </template>

          <!-- Acá va el nuevo tab para subramos -->
          <b-tabs nav-class="tomador-tabs" v-model="subRamoSelectedIndex">
            <b-tab v-for="(subramo, index) in subRamos" :key="index" @click="selectSubramo(subramo)">
              <template v-slot:title>
                <strong class="tab-text">{{ subramo }}</strong>
              </template>
              <!-- Acá va el contenido de toda la aplicación -->
            <b-card-text>
              <b-card no-body>
                <b-tabs pills card class="subtab" v-model="polizaSelectedIndex">
                  <b-tab :title="poliza.nro_pol" v-for="(poliza, index) in polizasPorSubramo" :key="index" ref="polizasTabs" @click="selectPoliza(poliza)">
                    <b-row>
                      <b-col sm="9">
                        <b-row>
                          <b-col sm="8">
                            <h3 class="text-primary">Póliza {{ polizaSelected.nro_pol }} - {{ polizaSelected.txt_desc_1 }}</h3>
                            <h3 class="text-primary" style="margin-top: 15px; margin-bottom: 25px">{{ polizaSelected.txt_desc }}</h3>
                          </b-col>
                          <b-col sm="4">
                            <p v-if="!$role(['productor'])">
                              <strong class="text-primary">Productor:</strong>
                              {{ productor }}
                            </p>
                            <p>
                              <strong class="text-primary">Asegurado:</strong>
                              {{ poliza.tipo == 'grupal' ? 'Según nómina' : asegurado }}
                            </p>
                            <p>
                              <strong class="text-primary" v-if="endosoSelected.renueva_de">Renueva de:</strong>
                              {{ endosoSelected.renueva_de }}
                            </p>
                            <p>
                              <strong class="text-primary" v-if="endosoSelected.renovada_por">Renovada por:</strong>
                              {{ endosoSelected.renovada_por }}
                            </p>
                          </b-col>
                          <b-col sm="12">
                            <strong class="text-primary">Cobertura:</strong>
                            <div class="small" v-html="parseCobertura(endosoSelected.cobertura)"></div>
                            <br />
                          </b-col>
                          <b-col sm="5">
                            <p>
                              <strong class="text-primary">Vigencia desde:</strong>
                              {{ endosoSelected.fec_vig_desde | dateFormat }}
                            </p>
                            <p>
                              <strong class="text-primary">Vigencia hasta:</strong>
                              {{ endosoSelected.fec_vig_hasta | dateFormat }}
                            </p>
                            <p>
                              <strong class="text-primary">Suma Asegurada:</strong>
                              {{ moneda(endosoSelected.moneda) }} {{ endosoSelected.suma_asegurada | intFormat }}
                            </p>
                          </b-col>
                          <b-col sm="5">
                            <p>
                              <strong class="text-primary">Prima: </strong>
                              {{ moneda(endosoSelected.moneda) }} {{ endosoSelected.prima | intFormat }}
                            </p>
                            <p>
                              <strong class="text-primary">Premio: </strong>
                              {{ moneda(endosoSelected.moneda) }} {{ endosoSelected.premio | intFormat }}
                            </p>
                            <p>
                              <strong class="text-primary">Forma de pago:</strong>
                              {{ endosoSelected.forma_pago }}
                            </p>
                            <p>
                              <strong class="text-primary">Cuotas:</strong>
                              {{ endosoSelected.cuotas }}
                            </p>
                          </b-col>
                          <b-col sm="2"></b-col>
                        </b-row>
                      </b-col>
                      <b-col sm="3">
                        <div v-if="showEndosos">
                          <b-select :options="endososList" class="mb-2" :value="endoso" @change="selectEndoso" />
                          <b-dropdown variant="outline-primary" text="PDF de Póliza / Endosos" class="w-100 mb-2">
                            <b-dropdown-item @click="enviarTomador"> <i class="fa fa-send"></i>Enviar al Tomador </b-dropdown-item>
                            <b-dropdown-item @click="solicitarCopiaImpresa"> <i class="fa fa-print"></i>Solicitar Copia Impresa </b-dropdown-item>
                            <b-dropdown-item @click="descargarArchivos"> <i class="fa fa-download"></i>Descargar </b-dropdown-item>
                          </b-dropdown>

                          <b-btn variant="outline-primary" block @click="$refs.modalInstrumentoPago.toggle()">Cambiar Instrumento de Pago</b-btn>
                          <b-btn variant="outline-primary" block @click="$refs.modalInformePago.toggle()">Informar Pago de Póliza</b-btn>

                          <b-btn variant="outline-primary" block @click="openSolicitudEndosos">Solicitar Endosos</b-btn>
                          <b-btn title="No disponible mientras el endoso seleccionado no sea el ultimo." v-if="onlyshow.includes(parseInt(polizaSelected.cod_ramo))" id="info-genCert-btn" variant="outline-primary" block @click="openGenCertificado">Generar Certificado</b-btn>
                          <b-btn v-if="endosoSelected.conducto == 'EFECTIVO'" variant="outline-primary" block @click="genCuponera">Generar Cuponera</b-btn>
                          <b-btn variant="outline-primary" block @click="openGenLibreDeuda" v-if="mostrarBotonLibreDeuda">Generar Libre Deuda</b-btn>

                          <!-- <b-dropdown variant="outline-primary" text="Cláusulas de No Repetición" class="w-100 mb-2 btn-no-repeticion">
                            <b-dropdown-item @click="openGenClauNoRep"> <i class="fas fa-pen-nib"></i>Generar Nueva</b-dropdown-item>
                            <b-dropdown-item @click="openEmpAsoc"> <i class="fas fa-user-tie"></i>Empresas Asociadas</b-dropdown-item>
                          </b-dropdown> -->
                          <!-- <b-btn variant="outline-primary" block @click="openEmpAsoc">Empresas Asociadas</b-btn> -->
                          <!-- <b-btn variant="outline-primary" block @click="descargaRecibos">Descargar Recibos</b-btn> -->
                          <!-- <b-btn variant="outline-primary" block @click="cartaNoSiniestra">Carta de No Siniestralidad</b-btn> -->
                        </div>
                        <div v-else class="text-center">
                          <i class="fa fa-spinner fa-spin" />
                        </div>
                      </b-col>
                    </b-row>
                    <div class="separator"></div>
                    <b-row>
                          <b-col>
                            <Comisiones
                                :nroPoliza="polizaSelected.nro_pol"
                                :nroEndoso="endosoSelected.nro_endoso"
                                :indice="index"
                                :estado="collapseComisiones"
                                >
                            </Comisiones>
                          </b-col>
                        </b-row>
                          <small style="display: none">{{collapseComisiones}}
                        {{collapseCobranzas}}</small>
                    <div class="separator"></div>
                    <div class="border">
                    <h4 v-b-toggle="'collapse-cobranzas'+index" class="text-primary m-3" style="cursor: pointer;">Cobranzas</h4>
                    <b-collapse :id="'collapse-cobranzas'+index" @show="mostrarCobranzas" v-model="collapseCobranzas">
                    <b-row v-if="!loadingCobranzas">
                      <b-col sm="12">
                        <b-row>
                          <b-col sm="4">
                            <ul>
                              <li><b-form-checkbox v-if="endosoSelected.moneda.indexOf('Dolares')>=0" v-model="enDolares" name="check-button" switch>U$D</b-form-checkbox></li>
                              <li>
                                <b class="text-primary">Instrumento:</b>
                                {{ endosoSelected.conducto }}
                              </li>
                              <li v-if="endosoSelected.conducto != 'EFECTIVO'">
                                <b class="text-primary">Nro. {{ endosoSelected.conducto }}</b>
                                XXXXXXXX{{ endosoSelected.tarjeta }}
                              </li>
                              <li>
                                <b class="text-primary">Moneda:</b>
                                {{ endosoSelected.moneda }}
                              </li>
                            </ul>
                          </b-col>
                          <b-col sm="4">
                            <ul>
                              <li>
                                <b class="text-primary">Vencido:</b>
                                {{ moneda(endosoSelected.moneda) }} {{ totalesCobranza.vencido | numberFormat }}
                              </li>
                              <li>
                                <b class="text-primary">A vencer:</b>
                                {{ moneda(endosoSelected.moneda) }} {{ totalesCobranza.a_vencer | numberFormat }}
                              </li>
                            </ul>
                          </b-col>
                          <b-col sm="4">
                            <ul>
                              <li>
                                <b class="text-primary">Pendiente:</b>
                                {{ moneda(endosoSelected.moneda) }} {{ totalesCobranza.pendiente | numberFormat }}
                              </li>
                              <li>
                                <b class="text-primary">Pagado:</b>
                                {{ enDolares?moneda(endosoSelected.moneda):'$' }} {{ totalesCobranza.pagado | numberFormat }}
                              </li>
                            </ul>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-row style="margin: 0; padding: 5px;">
                        <b-col sm="12">
                          <b-button style="float:right; margin:0px 5px 5px 0px" size="sm" variant="success" @click="descargarCobranzas">Exportar</b-button>
                          <b-table style="table-layout: fixed; text-align: center;" :items="cobranzas" bordered small :fields="columnasCobranza" sort-by="cuota">
                            <template #cell(Vencimiento)="data">
                              {{ data.item.Vencimiento.replace(/-/g, "/") }}
                            </template>

                            <template #cell(Fecha_pago)="data">
                              {{ data.item.Fecha_pago | dateFormat }}
                            </template>

                            <template #cell(importe)="data">
                              {{ moneda(endosoSelected.moneda) }} {{ data.item.importe | numberFormat }}
                            </template>

                            <template #cell(Importe_Pagado)="data">
                              {{ enDolares?moneda(endosoSelected.moneda):'$' }} {{ importePagado(data.item) | numberFormat }}
                            </template>

                            <template #cell(tipo_cambio)="data">
                              {{ (data.item.tipo_cambio && data.item.tipo_cambio.length)?
                                      data.item.tipo_cambio.length==1?('$ '+(parseFloat(data.item.tipo_cambio[0]).toLocaleString('en-US', {minimumFractionDigits: 2}).replaceAll('.', ','))):
                                                                      'ver pagos parciales':
                                                                      '-' }}
                            </template>

                            <template #cell(saldo)="data">
                              {{ moneda(endosoSelected.moneda) }} {{ data.item.saldo | numberFormat }}
                            </template>

                            <template #cell(Pagos_Parciales)="row" >
                              <b-button size="sm" @click="verPagosParcialesCuotas(row.item)" class="mr-2" v-if="mostrarBotonVer(row.item)">
                                Ver
                              </b-button>
                            </template>

                          <div slot="Vencimiento" slot-scope="data">{{ data.item.Vencimiento | dateFormat }}</div>
                          <div slot="Fecha_Pago" slot-scope="data">{{ data.item.Fecha_Pago | dateFormat }}</div>
                          <div slot="importe" slot-scope="data">{{ moneda(endosoSelected.moneda) }} {{ data.item.importe | numberFormat }}</div>
                          <div slot="Importe_Pagado" slot-scope="data">{{ moneda(endosoSelected.moneda) }} {{ data.item.Importe_Pagado | numberFormat }}</div>
                          <div slot="Estado" slot-scope="data">
                            <b-badge :variant="colorEstado(estado(data.item))">{{ estado(data.item) }}</b-badge>
                          </div>
                          <div slot="saldo" slot-scope="data">{{ moneda(endosoSelected.moneda) }} {{ data.item.saldo | numberFormat }}</div>
                        </b-table>
                      </b-col>
                      </b-row>
                    </b-row>
                    <b-row v-else>
                      <b-col sm="12">
                        <i class="fa fa-spinner fa-spin" />
                      </b-col>
                    </b-row>
                    </b-collapse>
                    </div>
                  </b-tab>
                </b-tabs>
              </b-card>
            </b-card-text>
            </b-tab>
          </b-tabs>
          <!-- Acá termina el nuevo tab para subramos -->

        </b-tab>

        <solicitud-endosos
          id="anchor-endosos"
          ref="solicitudEndoso"
          :tomador="$route.params.cod_tomador"
          :nombre-asegurado="polizaSelected.tipo == 'grupal' ? 'Según nómina' : asegurado"
          :nro-poliza="polizaSelected.nro_pol"
          :endoso="endosoSelected.nro_endoso"
        />

        <gen-certificado
          id="generar-certificado"
          ref="genCertificado"
          :nombre-asegurado="polizaSelected.tipo == 'grupal' ? 'Según nómina' : asegurado"
          :tomador="$route.params.cod_tomador"
          :nom-tomador="tomador.nombre"
          :nro-endoso="endosoSelected.nro_endoso"
          :nro-poliza="polizaSelected.nro_pol"
          :ramo="polizaSelected.cod_ramo"
          :cod-agente="this.polizaSelected.cod_agente"
        />

        <gen-libre-deuda
          id="generar-libre-deuda"
          ref="genLibreDeuda"
          :tomador="$route.params.cod_tomador"
          :nro-endoso="endosoSelected.nro_endoso"
          :nro-poliza="polizaSelected.nro_pol"
          :ramo="polizaSelected.cod_ramo"
        />

        <gen-clausula-no-repeticion
          id="generar-clausula-no-repeticion"
          ref="GenClausulaNoRepeticion"
          :nro-poliza="polizaSelected.nro_pol"
          :nro-endoso="endosoSelected.nro_endoso"
        />

        <ver-empresas-asociadas
          id="ver-empresas-asociadas"
          ref="VerEmpresasAsociadas"
          :nro-poliza="polizaSelected.nro_pol"
        />

        <desc-recibos
          id="desc-recibos"
          ref="descRecibos"
          :nombre-asegurado="polizaSelected.tipo == 'grupal' ? 'Según nómina' : asegurado"
          :tomador="$route.params.cod_tomador"
          :nro-endoso="endosoSelected.nro_endoso"
          :nro-poliza="polizaSelected.nro_pol"
        />
      </b-tabs>
    </b-card>

    <modal-cambio-mail ref="cambioMail" :tomador="tomador" :nro-poliza="polizaSelected.nro_pol"></modal-cambio-mail>

    <modal-cambio-tel ref="cambioTel" :tomador="tomador" :nro-poliza="polizaSelected.nro_pol"></modal-cambio-tel>

    <modal-instrumento-pago ref="modalInstrumentoPago" :nro-poliza="polizaSelected.nro_pol" />
    <modal-informe-pago ref="modalInformePago" :tomador="tomador" :polizas="polizas" :poliza-selected="polizaSelected" />

    <modal-descargas ref="descargasModal" :tomador="tomador" />
    <modal-copia-impresa ref="modalCopiaImpresa" :tomador="tomador" :nro-poliza="polizaSelected.nro_pol" :nro-endoso="endosoSelected.nro_endoso" />

    <modal-enviar-tomador ref="modalEnviarTomador" :tomador="tomador" :nro-poliza="polizaSelected.nro_pol" :nro-endoso="endosoSelected.nro_endoso" />

    <!-- Este modal mostrará los datos de pagos parciales de la cuota elegida -->
    <b-modal
      v-model="show"
      ref="modal"
      :title="pagosParcialesCuotaTitle"
      ok-only
    >
      <b-table style="table-layout: fixed"
        :items="pagosParcialesCuotaSelected"
        bordered
        small
        :fields="pagosParcialesCampos"
        sort-by="nro_correlativo">

        <template #cell(imp_premio_bruto)="data">
          {{ enDolares?moneda(endosoSelected.moneda):'$' }} {{ data.item.imp_premio_bruto*(!enDolares?data.item.tipo_cambio:1) | numberFormat }}
        </template>

        <template #cell(tipo_cambio)="data">
          {{'$ '}} {{ data.item.tipo_cambio | numberFormat }}
        </template>

        <template #cell(fec_cobranza)="data">
          {{ data.item.fec_cobranza | dateFormat }}
        </template>

      </b-table>
    </b-modal>
  </div>
</template>

<script>
import { numberFormat, dateFormat, intFormat, lower } from '@/helpers/filters';
import moment from 'moment';
import Autocomplete from '@/components/Autocomplete';
import ModalInformePago from '@/components/ModalInformePago';
import SolicitudEndosos from '@/components/Tomador/SolicitudEndosos';
import GenCertificado from '@/components/GenCertificado';
import GenLibreDeuda from '@/components/Tomador/GenLibreDeuda';
import GenClausulaNoRepeticion from '@/components/GenClausulaNoRepeticion';
import VerEmpresasAsociadas from '@/components/VerEmpresasAsociadas';
import DescRecibos from '@/components/DescRecibos';
import ModalInstrumentoPago from '@/components/ModalInstrumentoPago';
import ModalCambioMail from '@/components/ModalCambioMail';
import ModalCambioTel from '@/components/ModalCambioTel';
import ModalDescargas from '@/components/ModalDescargas';
import ModalCopiaImpresa from '@/components/ModalCopiaImpresa';
import ModalEnviarTomador from '@/components/ModalEnviarTomador';
import Comisiones from '@/components/Comisiones';

export default {
  components: {
    Autocomplete,
    SolicitudEndosos,
    ModalInformePago,
    GenCertificado,
    GenLibreDeuda,
    GenClausulaNoRepeticion,
    VerEmpresasAsociadas,
    DescRecibos,
    ModalInstrumentoPago,
    ModalCambioMail,
    ModalCambioTel,
    ModalDescargas,
    ModalCopiaImpresa,
    ModalEnviarTomador,
    Comisiones
  },
  data() {
    return {
      onlyshow: [10,14,17,18],//[10, 14, 17, 18, 80, 81],
      enDolares: true,
      showEndosos: false,
      verTomadorPolizasAll: false,
      polizas: [],
      polizaSelected: {},
      polizaSelectedIndex: 0,
      polizaSelectedIndexAll: 0,
      ramoSelected: '',
      ramoSelectedIndex: -1,
      subramoSelected: '',
      subRamoSelectedIndex: 0,
      subRamoIndexAux: 0,
      tomador: {},
      endosos: [],
      endosoSelected: {},
      endoso: 'Último Endoso',
      ultimoEndoso: true,
      cobranzas: [],
      collapseComisiones: false,
      collapseCobranzas: false,
      cambiado: false,
      instrumentoPago: {},
      pagosParciales: [],
      pagosParcialesCuotaSelected: [],
      pagosParcialesCuotaTitle: '',
      refreshCertificado: true,
      refreshLibreDeuda: true,
      refreshClausulaNoRepeticion: true,
      loadingCobranzas: true,
      tipoRamos: {
        seg_personas: ['ACCIDENTES PERSONALES', 'VIDA INDIVIDUAL', 'VIDA COLECTIVO', 'VIDA OBLIGATORIO', 'VIDA'],
        property: ['INCENDIO', 'CRISTALES', 'ROBO', 'INTEGRAL DE CONSORCIO', 'SEGURO TECNICO', 'COMBINADO FAMILIAR', 'INTEGRAL DE COMERCIO', 'RESP.CIVIL GENERAL', 'PROPERTY'],
        rc_profesional: ['RESP.CIVIL PROFESIONAL'],
      },
      productor: '',
      firstTime: true,
      show: false,
    };
  },
  methods: {
    importePagado(item){
      let importe;
      importe = item.Importe_Pagado.reduce((a, b, y) =>{
                            let cambio = (this.endosoSelected.moneda.toLowerCase().indexOf('dolares') > -1 &&!this.enDolares)? item.tipo_cambio[y]: 1;
                            return parseFloat(a)+parseFloat(b)*cambio;
                          } , 0);
      return importe;
    },
    moneda(moneda) {
      if (moneda) {
        if (moneda.toLowerCase().indexOf('dolares') > -1) {
          return 'U$S';
        } else {
          return '$';
        }
      }
    },
    selectRamo(ramo) {
      //NO
      this.ramoSelected = ramo;
      this.polizaSelectedIndex = 0;
      this.polizaSelectedIndexAll = 0
      this.selectPoliza(this.polizasPorRamo[this.polizaSelectedIndex]);
    },
    selectSubramo(subramo) {
      this.subramoSelected = subramo
      this.polizaSelectedIndex = 0
      this.polizaSelectedIndexAll = 0
      this.selectPoliza(this.polizasPorSubramo[this.polizaSelectedIndex])
    },
    selectPoliza: async function (poliza) {
      this.refreshCertificado = false;
	    this.refreshLibreDeuda = false;
	    this.refreshClausulaNoRepeticion = false;
      this.refreshEmpresasAsociadas = false;
      this.polizaSelected = poliza;
      //this.ramoSelectedIndex = this.ramos.findIndex((ramo) => ramo == poliza.desc_tipo_ramo);
      if (this.tipoRamos.rc_profesional.includes(poliza.desc_tipo_ramo)) {
        this.ramoSelectedIndex = this.ramos.indexOf('RC PROFESIONAL');
      } else if (this.tipoRamos.property.includes(poliza.desc_tipo_ramo)) {
        this.ramoSelectedIndex = this.ramos.indexOf('PROPERTY');
      } else if (this.tipoRamos.seg_personas.includes(poliza.desc_tipo_ramo)) {
        this.ramoSelectedIndex = this.ramos.indexOf('SEGURO DE PERSONAS');
      }
      this.ramoSelected = this.ramos[this.ramoSelectedIndex];
      this.subRamoSelectedIndex = this.subRamos.indexOf(poliza.desc_tipo_ramo)
      this.subRamoIndexAux = this.subRamos.indexOf(poliza.desc_tipo_ramo)
      this.subramoSelected = this.subRamos[this.subRamoSelectedIndex]

      this.endosos = await this.getEndosos(poliza.nro_pol);
      //console.log('endosos retribuidos');
      //console.log(this.endosos[0].id);
      // this.productor = await this.getProductor(this.polizaSelected.cod_agente);
      //await this.selectEndoso();
      this.endosoSelected = this.endosos[this.endosos.length-1];
      await this.selectEndoso();
    },
    getPolizasTomador(cod_tomador, cod_poliza) {
      let userauth = JSON.parse(sessionStorage.getItem('auth'))
      let usuarioCodAgente = userauth.cod_agente
      let rolUsuario = userauth.role.roles[0].id

      if(rolUsuario == 3){
        return this.$api('polizas/' + cod_tomador + '/'+ cod_poliza + '/'+ usuarioCodAgente).then((res) => res.data.data);
      }else if(rolUsuario == 2){
        let codAgenteProductorPoliza = this.$route.params.cod_agente_poliza
        return this.$api('polizas/' + cod_tomador + '/'+ cod_poliza + '/'+ codAgenteProductorPoliza).then((res) => res.data.data);
      }else{
        return this.$api('polizas/' + cod_tomador + '/'+ cod_poliza).then((res) => res.data.data);
      }
    },
    getPolizasTomadorAll(cod_tomador, cod_poliza) {
      let userauth = JSON.parse(sessionStorage.getItem('auth'))
      let usuarioCodAgente = userauth.cod_agente
      let rolUsuario = userauth.role.roles[0].id
      if(rolUsuario == 3){
        return this.$api('polizas-all/' + cod_tomador + '/'+ cod_poliza + '/'+ usuarioCodAgente).then((res) => res.data.data);
      }else if(rolUsuario == 2){
        let codAgenteProductorPoliza = this.$route.params.cod_agente_poliza
        return this.$api('polizas-all/' + cod_tomador + '/'+ cod_poliza + '/'+ codAgenteProductorPoliza).then((res) => res.data.data);
      }else{
        return this.$api('polizas-all/' + cod_tomador + '/'+ cod_poliza).then((res) => res.data.data);
      }
    },
    getProductor(cod_agente) {
      return this.$api('producer/' + cod_agente).then((res) => {
        return res.data.producer;
      });
    },
    getDatosTomador(cod_tomador) {
      //console.log(this.$store.state.filterCartera);
      return this.$api('tomador/show/' + cod_tomador).then((res) => {
        this.tomador = res.data.tomador;
        this.tomador.cod_tomador = cod_tomador;
      });
    },
    getEndosos(nro_poliza) {
      this.showEndosos = false;
      let userauth = JSON.parse(sessionStorage.getItem('auth'));
      let usuarioCodAgente = null;
      let rolUsuario = userauth.role.roles[0].id;

      //console.log('getEndosos '+nro_poliza);
      if(rolUsuario == 3){
        usuarioCodAgente = userauth.cod_agente
      }
      else if(rolUsuario == 2){
        usuarioCodAgente = Number.parseInt(this.$route.params.cod_agente_poliza, 10)
      }
      return this.$api
        .post('endoso/endosos', {
          nro_poliza: nro_poliza,
          cod_agente: usuarioCodAgente,
        })
        .then((res) => {
                //console.log('fin getEndosos');
                this.showEndosos = true;
                return res.data.data;
              })
        .catch(e => this.$toast.error('Error al retribuir los Endosos, recargue la pagina o verifique su conexion', 'Error'));
    },
    getCobranzas(cod) {
      return this.$api
        .post('endoso/cobranzas', {
          id_pv: cod,
        })
        .then((res) => res.data.data.map(function (e) {
          e.Vencimiento = moment(e.Vencimiento).format("DD-MM-YYYY");
          return e;
        }));
    },
    getPagosParciales(numPoliza, numEndoso) {
      return this.$api
        .post('endoso/pagos-parciales', {
          nro_poliza: numPoliza,
          nro_endoso: numEndoso,
        })
        .then((res) => res.data.data);
    },
    verPagosParcialesCuotas(record) {
      let pagosParcialesCuota = []
      if(this.pagosParciales.length > 0){
        pagosParcialesCuota = this.pagosParciales.filter(e => e.nro_cuota == record.cuota);
        pagosParcialesCuota.map((x, y) => x.tipo_cambio = record.tipo_cambio[y]);
        if(pagosParcialesCuota.length == 0){
          alert("La cuota elegida no registra ningún pago parcial en el sistema")
        }else{
          // En caso de no haber pagosParciales para la cuota, devolver un alert y no abrir el modal
          this.pagosParcialesCuotaSelected = pagosParcialesCuota
          this.pagosParcialesCuotaTitle = 'Pagos Parciales de Cuota N°' + record.cuota
          this.show = true
        }
        console.log(pagosParcialesCuota);
      }else{
        alert("La poliza y endosos elegidos no registran ningún pago parcial en el sistema")
      }
    },
    selectEndoso: async function (val) {
      this.closeAll();
      let nro_endoso = this.endosos.length - 1;
      let endoso = ""
      if (val) {
        if (isNaN(val)) {
          nro_endoso = val.split(' ')[1];
        } else {
          nro_endoso = val;
        }
        endoso = this.endosos.find(e => e.nro_endoso == nro_endoso)
        this.endoso = 'Endoso ' + endoso.nro_endoso;
      }else{
        endoso = this.endosos[nro_endoso];
        this.endoso = 'Endoso ' + endoso.nro_endoso;
      }

      let loading = this.$loading.show();
      await this.$api.post(
        'endoso/endososextra',
        {
          nro_poliza: this.polizaSelected.nro_pol,
	        nro_endoso: nro_endoso,
        }
      )
      .then(r=>{
        endoso.renovada_por = r.data.renovada_por;
	      endoso.conducto = r.data.conducto;
	      endoso.moneda = r.data.moneda;
	      endoso.cobertura = r.data.cobertura;
        this.endosos[this.endosos.indexOf(endoso)] = endoso;
        //console.log('esto trae de extra->');
        //console.log(this.endosos[nro_endoso]);
        loading.hide();
      });

      this.endosoSelected = this.endosos[this.endosos.indexOf(endoso)];
      //console.log('estos son los datos del endoso:');
      //console.log(this.endosoSelected);

      //console.log('->>>'+endoso.toString());
      this.productor = endoso.txt_cheque_a_nom;

      this.ultimoEndoso = this.endosos.indexOf(endoso) == this.endosos.length-1;
      //console.log(this.ultimoEndoso);

      // Obtener datos sobre pagos parciales de las cuotas para el endoso indicado de la poliza especifica
      //this.pagosParciales = await this.getPagosParciales(this.polizaSelected.nro_pol, this.endosoSelected.nro_endoso);
      // //console.log(this.pagosParciales);
      //this.endosoSelected = endoso;
      //console.log(this.endosoSelected.nro_endoso);

    },
    sinPagosParciales(){
      return !this.cobranzas.map(x => this.pagosParciales.filter(y => y.nro_cuota == x.cuota).length>1).includes(true);

    },
    mostrarBotonVer(item){
      console.log('item',item);
      const suma = this.pagosParciales.reduce((acumulador, elemento) => {
      if (elemento.nro_cuota === item.cuota) {
          return acumulador + elemento.imp_premio_bruto; // Suma el valor del elemento al acumulador
        }
        return acumulador; // Retorna el acumulador sin cambios si la condición no se cumple
      }, 0); // 0 es el valor inicial del acumulador

      const importe_pagado = this.importePagado(item) || 0;
      console.log('suma',suma); // Imprime la suma de los valores de los elementos cuyo nro_cuota es igual a 1
      if (suma > 0 && importe_pagado < item.importe) {
        return true;
      }
      return false;
    },

    descargarCobranzas: async function() {
      const loading = this.$loading.show();
      const payload = {
        id_pv: this.endosoSelected.id,
        nro_endoso: this.nroEndoso,
        formato: 'PDF',
        detalle: this.sinPagosParciales()?false:confirm('Incluir el detalle de las cuotas?'),
        pesificado: !this.enDolares
      };
      await this.$api({
        url: 'endoso/cobranzas',
        method: 'POST',
        responseType: 'blob',
        data: payload
      }).then(res => {
        loading.hide();
        const fileURL = URL.createObjectURL(res.data);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style="display: none";
        a.href = fileURL;
        a.download = 'Cobranzas.pdf'
        a.click();
        window.URL.revokeObjectURL(fileURL);
        document.body.removeChild(a);
      }).catch(err => {
        const toast = this.$toast;
        const fr = new FileReader();
        fr.onload = function() {
          toast.error('No se puede descargar el archivo. ' + fr.result.replace(/"/g, ''));
        };
        fr.readAsText(err.response.data);
        loading.hide();
      });

    },
    mostrarCobranzas: async function(){
      // Obtener cobranzas
      this.loadingCobranzas = true;
      this.cobranzas = await this.getCobranzas(this.endosoSelected.id);
      this.pagosParciales = await this.getPagosParciales(this.polizaSelected.nro_pol, this.endosoSelected.nro_endoso);
      this.loadingCobranzas = false;
    },
    estado(item) {
      if (item.Estado === 'Imputado') {
        return 'Imputado';
      } else if (item.Estado === 'Pendiente') {
        const vencimiento = moment(item.Vencimiento).unix();
        if (vencimiento >= moment().unix()) return 'Pendiente';
        else return 'Vencido';
      } else if (item.Estado === 'Pago parcial') {
        return 'Pago parcial';
      }
    },
    polizaVigente(vig_hasta) {
      const vig = moment(vig_hasta).format('YMMDD');
      const now = moment().format('YMMDD');

      return vig >= now;
    },
    colorEstado(estado) {
      if (estado === 'Pendiente') {
        return 'primary';
      } else if (estado === 'Imputado') {
        return 'success';
      } else if (estado === 'Pago parcial') {
        return 'warning';
      } else {
        return 'danger';
      }
    },
    closeAll() {
      this.refreshCertificado = true;
      this.refreshLibreDeuda = true;
      this.refreshClausulaNoRepeticion = true;
      this.refreshEmpresasAsociadas = true;
      this.collapseComisiones = false;
      this.collapseCobranzas = false;

      for (const index in this.$refs) {
        this.$refs[index].visible = false;
      }
    },
    getArchivos() {
      let nro_pol = this.polizaSelected.nro_pol,
        cod_ramo = this.polizaSelected.cod_ramo,
        nro_end = this.endosoSelected.nro_endoso,
        cod_age = this.$store.state.auth.cod_agente?this.$store.state.auth.cod_agente:999,
        tomador = this.tomador.nombre,
        cod_productor = this.$route.params.cod_agente_poliza ;

      const urls = [];
      return this.$api(`polizas/archivos/${cod_ramo}/${nro_pol}/${nro_end}/${cod_age}/${cod_productor}/${tomador}`)
        .then((res) => {
          let results = res.data;

          if (!results.url_descargas.length) {
            this.$toast.warning('No se encontraron archivos disponibles para la descarga.');
            return null;
          }

          //console.log("URLS de descarga: ", results)
          for (const url of results.url_descargas) {
            if (url.toLowerCase().indexOf('toorg') > -1) {
              if (this.$role(['Administrador', 'Organizador', 'Organizador Limitado'])) {
                //console.log("URL para Admin y Orgs: ", url)
                urls.push(url);
              }
            } else {
              //console.log("URL para los con indexOf(toorg) <= -1: ", url)
              urls.push(url);
            }
          }

          return urls;
        })
        .catch((err) => {
          //console.log(err);
          return null;
        });
    },
    descargarArchivos: async function () {
      this.closeAll();

      let loading = this.$loading.show();

      const urls = await this.getArchivos();

      if (urls) {
        this.$refs.descargasModal.visible = true;
        this.$refs.descargasModal.archivos = urls;
      }

      loading.hide();
    },
    enviarTomador: async function () {
      this.closeAll();

      let loading = this.$loading.show();

      const urls = await this.getArchivos();

      if (urls) {
        this.$refs.modalEnviarTomador.visible = true;
        this.$refs.modalEnviarTomador.archivos = urls;
      }

      loading.hide();
    },
    solicitarCopiaImpresa: async function () {
      this.closeAll();

      let loading = this.$loading.show();

      const urls = await this.getArchivos();

      if (urls) {
        this.$refs.modalCopiaImpresa.visible = true;
        this.$refs.modalCopiaImpresa.archivos = urls;
      }

      loading.hide();
    },
    openSolicitudEndosos() {
      this.closeAll();
      this.$refs.solicitudEndoso.visible = true;
      setTimeout(() => {
        location.hash = '#anchor-endosos';
      });
    },
    openGenCertificado() {
      if (!this.ultimoEndoso){
        this.$toast.warning('El endoso seleccionado no es el último. Utilizar PDF de Póliza / Endosos o bien ir al último endoso.');
        return;
      }
      if (!this.polizaVigente(this.endosoSelected.fec_vig_hasta)) {
        this.$toast.error('La póliza no está vigente. No se puede generar el certificado.');
        return;
      }

      this.$api.post('endoso/sin-deuda', {
        nro_pol: this.polizaSelected.nro_pol,
        cod_ramo: this.polizaSelected.cod_ramo,
        nro_endoso: this.endosoSelected.nro_endoso
      })
        .then(r => {
          if (r.data == 'Ok'){
            this.closeAll();
            this.$refs.genCertificado.visible = true;
                setTimeout(() => {
                  location.hash = '#generar-certificado';
                });
          }
        })
        .catch(err => {

            this.$toast.error(err.response.data);
          }
        );

    },
    openGenLibreDeuda() {
      this.closeAll();
      /*if (!this.polizaVigente(this.endosoSelected.fec_vig_hasta)) {
        this.$toast.error('La póliza no está vigente. No se puede generar el certificado.');
        return;
      }*/
      this.$refs.genLibreDeuda.visible = true;
      setTimeout(() => {
        location.hash = '#generar-libre-deuda';
      });
    },
    genCuponera() {
      this.closeAll();

      if (this.endosoSelected.conducto.toLowerCase() !== 'efectivo') {
        this.$toast.warning('La cuponera de pago es sólo para pólizas en efectivo.');
        return null;
      }

      this.$api({
        url: 'endoso/cuponera',
        method: 'POST',
        responseType: 'blob',
        data: {
          cod_ramo: this.polizaSelected.cod_ramo,
          ramo: this.ramoSelected,
          poliza: this.polizaSelected.nro_pol,
          id_pv: this.endosoSelected.id,
          endoso: this.endosoSelected.nro_endoso,
          asegurado: this.tomador.nombre,
          cuit: this.tomador.datos_fiscales.cuit,
          cod_agente: this.polizaSelected.cod_agente,
          moneda: this.endosoSelected.moneda,
        },
      })
        .then((res) => {
          const fileURL = URL.createObjectURL(res.data);
          window.open(fileURL);
        })
        .catch((err) => {
          const toast = this.$toast;
          const fr = new FileReader();
          fr.onload = function () {
            toast.warning(fr.result.replace(/"/g, ''));
          };
          fr.readAsText(err.response.data);
        });
    },
    openGenClauNoRep() {
      if (!this.polizaVigente(this.endosoSelected.fec_vig_hasta)) {
        this.$toast.error('La póliza no está vigente. No se puede generar la claúsula de no repetición.');
      } else {
        this.closeAll();
        this.$refs.GenClausulaNoRepeticion.visible = true;
        setTimeout(() => {
          location.hash = '#generar-clausula-no-repeticion';
        });
      }
    },
    openEmpAsoc() {
      if (!this.polizaVigente(this.endosoSelected.fec_vig_hasta)) {
        this.$toast.error('La póliza no está vigente. Ya no se pueden administrar las empresas de este productor.');
      } else {
        this.closeAll();
        this.$refs.VerEmpresasAsociadas.visible = true;
        setTimeout(() => {
          location.hash = '#ver-empresas-asociadas';
        });
      }
    },
    descargaRecibos() {
      this.closeAll();
      this.$refs.descRecibos.visible = true;
      setTimeout(() => {
        location.hash = '#desc-recibos';
      });
    },
    cartaNoSiniestra() {
      this.closeAll();
      this.$api({
        method: 'POST',
        url: 'siniestros/carta-no-siniestra',
        responseType: 'blob',
        data: {
          nro_poliza: this.polizaSelected.nro_pol,
        },
      }).then((res) => {
        const fileURL = URL.createObjectURL(res.data);
        window.open(fileURL);
      });
    },
    selectVistaPolizas(){
      this.verTomadorPolizasAll = this.verTomadorPolizasAll ? false : true
    },
    parseCobertura(values) {
      if (Array.isArray(values)) {
        return values.join('<br>');
      }
      return values;
    },
  },
  computed: {
    pagosParcialesCampos(){
       return [
        {
          key: 'nro_correlativo',
          label: 'Nro. Correlativo',
          class: 'text-center',
          visible: true
        },
        {
          key: 'nro_recibo',
          label: 'Nro. Recibo',
          class: 'text-center',
          visible: true
        },
        {
          key: 'imp_premio_bruto',
          label: 'Importe Premio Bruto',
          class: 'text-center',
          visible: true
        },
        {
          key: 'tipo_cambio',
          label: 'Tipo Cambio de Cobranza',
          class: 'text-center',
          visible: !this.enDolares
        },
        {
          key: 'fec_cobranza',
          label: 'Fecha Cobranza',
          class: 'text-center',
          visible: true
        }
      ].filter(x => x.visible);
    },
    columnasCobranza(){
      return [{key:'cuota', visible:true},
              {key:'Vencimiento', visible:true},
              {key:'Fecha_pago', visible:true},
              {key:'Estado', visible:true},
              {key:'importe', visible:true},
              {key:'Importe_Pagado', visible:true},
              {key:'tipo_cambio', label:'Tipo de Cambio Cobranza', visible: !this.enDolares},
              {key:'saldo', visible:true},
              {key:'Pagos_Parciales', visible:true}].filter(x=> x.visible);
    },
    mostrarBotonLibreDeuda(){
      return parseInt(this.polizaSelected.cod_ramo) != 14;
    },
    asegurado() {
      return this.$route.params.asegurado;
    },
    vistaPolizasTomador() {
      if (this.verTomadorPolizasAll) return "FAMILIA DE POLIZAS";
      return "POLIZAS TOMADOR";
    },
    polizasPorRamo() {
      if (this.ramoSelected == 'RC PROFESIONAL') {
        return this.polizas.filter((p) => this.tipoRamos.rc_profesional.includes(p.desc_tipo_ramo));
      } else if (this.ramoSelected == 'PROPERTY') {
        return this.polizas.filter((p) => this.tipoRamos.property.includes(p.desc_tipo_ramo));
      } else if (this.ramoSelected == 'SEGURO DE PERSONAS') {
        return this.polizas.filter((p) => this.tipoRamos.seg_personas.includes(p.desc_tipo_ramo));
      }
    },
    polizasPorSubramo() {
      return this.polizas.filter((p) => p.desc_tipo_ramo == this.subramoSelected);
    },
    polizasList() {
      return this.polizasPorRamo.map((p) => ({
        text: p.nro_pol,
        value: p.nro_pol,
      }));
    },
    ramos() {
      let ramos = [];
      this.polizas.forEach((p) => {
        let item = '';
        item = this.tipoRamos.seg_personas.includes(p.desc_tipo_ramo) ? 'SEGURO DE PERSONAS' : this.tipoRamos.property.includes(p.desc_tipo_ramo) ? 'PROPERTY' : 'RC PROFESIONAL';
        if (ramos.indexOf(item) === -1) {
          ramos.push(item);
        }
      });
      return ramos;
    },
    subRamos(){
      let subramos = []
      let item = ''
      if(this.ramoSelected == "SEGURO DE PERSONAS"){
        // //console.log(this.ramoSelected)
        this.tipoRamos.seg_personas.forEach((subrama) => {
          this.polizas.forEach((p) => {
            if(p.desc_tipo_ramo == subrama){
              item = subrama
              if (subramos.indexOf(item) === -1) {
                subramos.push(item)
              }
            }
          })
        })
      }else if (this.ramoSelected == "PROPERTY"){
        this.tipoRamos.property.forEach((subrama) => {
          this.polizas.forEach((p) => {
            if(p.desc_tipo_ramo == subrama){
              item = subrama
              if (subramos.indexOf(item) === -1) {
                subramos.push(item)
              }
            }
          })
        })
      }else{ //Si es RC Profesional
        item = 'RESP.CIVIL PROFESIONAL'
        if (subramos.indexOf(item) === -1) {
          subramos.push(item)
        }
      }
      return subramos
    },
    endososList() {
      return this.endosos.map((item) => 'Endoso ' + item.nro_endoso);
    },
    totalesCobranza() {
      let pendiente = this.endosoSelected.premio;
      var resu = this.cobranzas.reduce(
        (acc, item) => {
          let importe_pagado = this.importePagado(item) || 0;
          pendiente -= importe_pagado;
          acc.pendiente = pendiente > 0 ? pendiente : 0;
          if (typeof item.Importe_Pagado !== 'undefined') {
            acc.pagado += Number(importe_pagado)//item.Importe_Pagado);
          }
          if (item.Estado == 'Pendiente') {
            const vencimiento = moment(item.Vencimiento).unix();
            if (vencimiento >= moment().unix()) {
              acc.a_vencer += Number(item.importe);
            } else {
              acc.vencido += Number(item.importe);
            }
          }
          return acc;
        },
        {
          pagado: 0,
          pendiente: 0,
          vencido: 0,
          a_vencer: 0,
        }
      );
      //console.log(resu);
      return resu;
    },
  },
  watch: {
    polizasPorSubramo(polizas) {
      // //console.log("Indice de poliza antes de entrar a polizasPorRamo: " + this.polizaSelectedIndex)
      setTimeout(() => {
        // //console.log("Esperamos 1 segundo que carguen");
        if (polizas && polizas.length) {
          const nro_pol = this.$route.params.nro_pol;
          if (this.firstTime) {
            setTimeout(() => {
              this.polizaSelectedIndex = polizas.findIndex((pol) => pol.nro_pol == nro_pol);
            });
            this.firstTime = false;
          } else {
            this.polizaSelectedIndex = this.polizaSelectedIndexAll;
            this.subRamoSelectedIndex = this.subRamoIndexAux;
          }
        }
      }, 500)
    },
    polizaSelectedIndex() {
      // //console.log("En el watch de polizaSelectedIndex()")
      // //console.log(this.polizaSelectedIndex)
      this.endosoSelected = {};
      this.selectEndoso();
    },
    async verTomadorPolizasAll(val){
      let poliza = {}
      let polizaAnteriorIndex = 0
      if(val){
        poliza = this.polizas.find((pol) => pol.nro_pol == this.polizaSelected.nro_pol)
        this.polizas = await this.getPolizasTomadorAll(this.$route.params.cod_tomador, this.polizaSelected.nro_pol)
        // //console.log("Poliza seleccionada antes de pasar a todos: ", poliza)
        polizaAnteriorIndex = this.polizasPorSubramo.findIndex((pol) => pol.nro_pol == poliza.nro_pol)
        this.selectPoliza(poliza)
        this.polizaSelectedIndex = polizaAnteriorIndex
        this.polizaSelectedIndexAll = polizaAnteriorIndex
      }else{
        poliza = this.polizas.find((pol) => pol.nro_pol == this.polizaSelected.nro_pol)
        this.polizas = await this.getPolizasTomador(this.$route.params.cod_tomador, this.polizaSelected.nro_pol)
        // //console.log("Poliza seleccionada antes de pasar a familia: ", poliza)
        polizaAnteriorIndex = this.polizasPorSubramo.findIndex((pol) => pol.nro_pol == poliza.nro_pol)
        this.selectPoliza(poliza)
        this.polizaSelectedIndex = polizaAnteriorIndex
        this.polizaSelectedIndexAll = polizaAnteriorIndex
      }
      this.subRamoSelectedIndex = this.subRamos.indexOf(poliza.desc_tipo_ramo)
      this.subRamoIndexAux = this.subRamos.indexOf(poliza.desc_tipo_ramo)
      this.subramoSelected = this.subRamos[this.subRamoSelectedIndex]
    }
  },
  filters: { dateFormat, numberFormat, intFormat, lower },
  created: async function () {
    this.polizas = await this.getPolizasTomador(this.$route.params.cod_tomador, this.$route.params.nro_pol);
    await this.getDatosTomador(this.$route.params.cod_tomador);
    var nro_pol = this.$route.params.nro_pol;
    const poliza = this.polizas.find((pol) => pol.nro_pol == nro_pol);
    await this.selectPoliza(poliza);
  },
};
</script>
